import { Navigate, useParams } from "react-router-dom";

/**
 * Detail views and archived lists became modals over their list page (decision D2).
 * These keep the original routes resolving — they redirect to the list with the query
 * param that opens the corresponding modal, so existing links and bookmarks don't 404.
 */

export const CustomerDetailRedirect = () => {
	const { uuid } = useParams();
	return <Navigate to={`/customers?customer=${uuid ?? ""}`} replace />;
};

export const ArchivedCustomersRedirect = () => <Navigate to="/customers?archived=1" replace />;

export const ArchivedInventoryRedirect = () => <Navigate to="/inventory?archived=1" replace />;

export const ArchivedInvoicesRedirect = () => <Navigate to="/invoices?archived=1" replace />;

export const InvoiceDetailRedirect = () => {
	const { uuid } = useParams();
	return <Navigate to={`/invoices?invoice=${uuid ?? ""}`} replace />;
};

/**
 * `/settlements/:id` had no real data source — the old page rendered hardcoded sample
 * values and never called the API. Settlement detail is now a modal on the Settlements
 * page (decision D2), so this route redirects there.
 */
export const SettlementDetailRedirect = () => <Navigate to="/settlements" replace />;
